import { takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'

import * as fromCart from '../../../cart/reducers'
import * as fromCheckout from '../../reducers'
import * as fromAuth from '../../../auth/reducers'

import * as cart from '../../../cart/actions/cart'
import * as checkout from '../../actions/checkout'
import * as catalog from '../../../catalog/actions/catalog'

import { AddCartEvent, ApiOrder, ApiOrderline, ExtraCost } from '../../../cart/models/cart-models'
import { Address } from '../../../core/models/address'

import { ContainerBase } from '../../../core/base/container-base'
import chaining from '../../../core/helpers/chaining';
import * as products from '../../../catalog/actions/product';
import { DetailsContainer } from '../../../catalog/containers/details-container/details-container';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageRoutingService } from '../../../core/services/page-routing.service';
import { Setting } from '../../../core/models/setting';
import * as fromBase from '../../../base/reducers';
import { Product } from '../../../core/models/product';
import { UXPage } from '../../../core/models/ux-page';
import { Customer } from '../../../core/models/customer';
import { BackorderCounts } from '../../models/backorder-counts';
import { Discount } from '../../../core/models/discount';

@Component({
  selector: 'app-checkout-container',
  templateUrl: './template.html'
})
export class CheckoutContainer extends ContainerBase implements OnInit, OnDestroy {
  cartOrder$: Observable<ApiOrder>
  addresses$: Observable<Address[]>
  checkoutPageSettings$: Observable<Setting>
  quantityPicker$: Observable<string>
  deliverydates$: Observable<string[]>
  backordercounts$: Observable<BackorderCounts>
  customerDiscounts$: Observable<Discount[]>
  extraCosts$: Observable<ExtraCost[]>

  orderLines$: Observable<ApiOrderline[]>
  orderLines: ApiOrderline[]

  committing$: Observable<boolean>
  commitError$: Observable<any>

  customerMinOrderValue$: Observable<number>

  constructor(
    private store: Store<fromCheckout.State>,
    private pageRoutingSvc: PageRoutingService,
    private modalSvc: NgbModal
  ) {
    super()
    this.pageRoutingSvc.breadcrumbsStatus = false
    this.pageRoutingSvc.simplifiedHeaderStatus = false // SK 19-02-2019 changed to false

    this.cartOrder$ = store
      .pipe(
        select(fromCart.getOrder),
        takeUntil(this.destroyed$)
      )

    this.checkoutPageSettings$ = store
      .pipe(
        select(fromBase.getCheckoutPageSettings),
        takeUntil(this.destroyed$)
      )
    this.quantityPicker$ = store
      .pipe(
        select(fromBase.getQuantityPicker),
        takeUntil(this.destroyed$)
      )
    this.addresses$ = store
      .pipe(
        select(fromAuth.getAddresses),
        takeUntil(this.destroyed$)
      )

    this.committing$ = store
      .pipe(
        select(fromCheckout.isCreating),
        takeUntil(this.destroyed$)
      )
    this.commitError$ = store
      .pipe(
        select(fromCheckout.getError),
        takeUntil(this.destroyed$)
      )
    this.orderLines$ = store
      .pipe(
        select(fromCart.getCurrentOrderLines),
        takeUntil(this.destroyed$)
      )
    this.orderLines$
      .subscribe(orderLines => this.orderLines = orderLines)

    this.customerMinOrderValue$ = store
      .pipe(
        select(fromAuth.getCustomerMinOrderValue),
        takeUntil(this.destroyed$)
      )

    this.deliverydates$ = store
      .pipe(
        select(fromCheckout.getDeliveryDates),
        takeUntil(this.destroyed$)
      )

    this.backordercounts$ = store
      .pipe(
        select(fromCheckout.getBackorderCounts),
        takeUntil(this.destroyed$)
      )

    this.customerDiscounts$ = store
      .pipe(
        select(fromAuth.getCustomerDiscounts),
        takeUntil(this.destroyed$)
      )

    this.extraCosts$ = store
      .pipe(
        select(fromCart.getOrderExtraCosts),
        takeUntil(this.destroyed$)
      )
  }

  ngOnInit() {
    this.store.dispatch(new checkout.ClearError())
    this.store.dispatch(new checkout.GetDeliveryDates())
    this.store.dispatch(new checkout.GetBackorderCounts())

  }

  ngOnDestroy() {
    this.store.dispatch(new checkout.ClearDeliveryDates())
    this.pageRoutingSvc.breadcrumbsStatus = true
    this.pageRoutingSvc.simplifiedHeaderStatus = false
  }

  detailsChanged(order: ApiOrder) {
    this.store.dispatch(new checkout.Set(order))
  }

  checkoutOrder(order: ApiOrder) {
    this.store.dispatch(new checkout.Submit(order))
  }

  changeLine(event: AddCartEvent) {
    const orderLineId = chaining(this.orderLines.find(line => chaining(line, 'product._id') === chaining(event, 'product')), '_id')

    if (chaining(event, 'quantity') > 0) {
      this.store.dispatch(new cart.Add({
        product: event.product,
        quantity: event.quantity,
        includeExtraCosts: event.includeExtraCosts
      }))
    } else if (event.quantity <=0 && orderLineId)
      this.store.dispatch(new cart.Remove({
        lineId: orderLineId,
        includeExtraCosts: event.includeExtraCosts
      }))
  }

  deleteLine($event) {
    this.store.dispatch(new cart.Remove({
      lineId: $event,
      includeExtraCosts: true
    }))
  }

  openDetails(product: Product) {
    this.store.dispatch(new catalog.Init())
    this.store.dispatch(new products.Select(product))
    this.modalSvc.open(DetailsContainer, {centered: true, size: 'lg'})
  }
}
